import React, { useState } from "react";
import PrimaryHeader from "../../../components/common/primaryHeader";
import "./PatientList.scss";
import UsersImg from "../../../assets/images/users.svg";
import User2Img from "../../../assets/images/user-2.svg";
import User3Img from "../../../assets/images/user-3.svg";
import { TabView, TabPanel } from "primereact/tabview";
import AllReport from "./AllReport.jsx";
import { exportCSV, exportExcel, exportPdf } from "../../../utils/exportUtils";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import { commonPostApi } from "../../../utils/apiService.js";

const PatientListReport = ({ purpose }) => {
  const [show, setShow] = useState(false);
  const [selectOption, setSelectOption] = useState(1);
  const [date, setDate] = useState({});
  const [search, setSearch] = useState("");
  const [campPatientDashboard, setCampPatientDashboard] = useState([]);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [navigatorState, setNavigatorState] = useState(null);

  const patientDashboard = (startDate, endDate) => {
    setDate({
      startDate: startDate,
      endDate: endDate,
    });
  };

  function handleSearchChange(value) {
    setSearch(value);
  }

  function getPatientDashboard(visitName) {
    const purpose = campPatientDashboard?.find(
      (visit) => visit.name === visitName
    );
    return purpose?.count;
  }

const fetchAllPatientReportList = async () => {
  if (!navigatorState) return [];

  const exportObj = {
    purpose: navigatorState.purpose,
    page: 1,
    limit: navigatorState.totalRecords, 
    sortFields: [[navigatorState.sortBy, navigatorState.sortDir]],
    startDate: date?.startDate,
    endDate: date?.endDate,
    searchValue: search || ""
  };

  const res = await commonPostApi(API_ENDPOINTS.CAMP_MANAGER_REPORT_PATIENT,exportObj);
  return res?.data?.data || [];
};



  return (
    <>
      <div className="patients-main-container">
        <div className="p-4 mt-2 Patients__date-container patient-list-report-header">
          <PrimaryHeader
            searchHeaderLable={"Patient List"}
            isSearchEnabled={true}
            isDownloadButton={true}
            exportCSV={async() =>{
              const allData = await fetchAllPatientReportList();
              exportCSV(allData, columns, "PatientReport_List");
            }}
            exportExcel={async () =>{
              const allData = await fetchAllPatientReportList();  
              exportExcel(allData, columns, "PatientReport_List")
            }}
            exportPdf={async() => {
              const allData = await fetchAllPatientReportList();
              exportPdf(allData, columns, "PatientReport_List");
            }}
            placeholder={"Search Patients"}
            isCalenderEnabled={true}
            selectOption={selectOption}
            setSelectOption={setSelectOption}
            show={show}
            value={values}
            setShow={setShow}
            onDateRangeChange={patientDashboard}
            onChange={handleSearchChange}
          />
          <div className="Patients__card-container mt-2">
            <ul className="Patients__card-holder Patients__list">
              <li>
                <div className="card-left-sec">
                  <p className="card-title">Visits</p>
                  <p className="card-info">
                    <span className="total-count">
                      {getPatientDashboard("Visits") || 0}
                    </span>
                  </p>
                </div>
                <div className="card-right-sec">
                  <span className="card-icon bg-one">
                    <img src={UsersImg} alt="" />
                  </span>
                </div>
              </li>

              <li>
                <div className="card-left-sec">
                  <p className="card-title">1st (New)</p>
                  <p className="card-info">
                    <span className="total-count">
                      {getPatientDashboard("1st (New)") || 0}
                    </span>
                  </p>
                </div>
                <div className="card-right-sec">
                  <span className="card-icon bg-two">
                    <img src={User2Img} alt="" />
                  </span>
                </div>
              </li>
              <li>
                <div className="card-left-sec">
                  <p className="card-title">7th (Return)</p>
                  <p className="card-info">
                    <span className="total-count">
                      {getPatientDashboard("7th (Return)") || 0}
                    </span>
                  </p>
                </div>
                <div className="card-right-sec">
                  <span className="card-icon bg-three">
                    <img src={User3Img} alt="" />
                  </span>
                </div>
              </li>
              <li>
                <div className="card-left-sec">
                  <p className="card-title">14th (Return)</p>
                  <p className="card-info">
                    <span className="total-count">
                      {getPatientDashboard("14th (Return)") || 0}
                    </span>
                  </p>
                </div>
                <div className="card-right-sec">
                  <span className="card-icon bg-three">
                    <img src={User3Img} alt="" />
                  </span>
                </div>
              </li>
              <li>
                <div className="card-left-sec">
                  <p className="card-title">40th (Return)</p>
                  <p className="card-info">
                    <span className="total-count">
                      {getPatientDashboard("40th (Return)") || 0}
                    </span>
                  </p>
                </div>
                <div className="card-right-sec">
                  <span className="card-icon bg-three">
                    <img src={User3Img} alt="" />
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="Logistics__table-container">
        <div className="tab-view-sec">
          <TabView>
            {purpose.map((item) => (
              <TabPanel header={item.name} key={item.lookup_id}>
                <AllReport
                  api={API_ENDPOINTS.CAMP_MANAGER_REPORT_PATIENT}
                  dashboardApi={
                    API_ENDPOINTS.CAMP_MANAGER_REPORT_PATIENT_DASHBOARD
                  }
                  setCampPatientDashboard={setCampPatientDashboard}
                  visit={item.lookup_id}
                  date={date}
                  search={search}
                  parentSetProducts={setColumns}
                  parentSetValues={setValues}
                  parentSetNavigator={setNavigatorState}
                />
              </TabPanel>
            ))}
          </TabView>
        </div>
      </div>
    </>
  );
};

export default PatientListReport;
